import { createGlobalStyle } from 'styled-components';
import styled from 'styled-components';
import { Label, Button } from 'scorer-ui-kit';

const GlobalStyle = createGlobalStyle`
* , body{
  box-sizing: border-box;
}
body, html {
  min-width: 100%;
  min-height: 100vh;
  margin: 0;
  height: 100%;
}
html {
  background-repeat: no-repeat, repeat;
  background-image: linear-gradient(to bottom, hsla(210, 20%, 98%, 67%), hsla(210, 20%, 96%, 67%));
  /* background-image: radial-gradient(circle at 55% 1%, #303335, #212427 117%), url(./noise.png); */

}
body {
  font-family: Monorale, Hiragino Sans, "ヒラギノ角ゴシック", Hiragino Kaku Gothic ProN, "ヒラギノ角ゴ ProN W3", Roboto, YuGothic, "游ゴシック", Meiryo, "メイリオ", sans-serif;
  color: hsl(0, 0%, 50%);;
}
#root {
  height: 100%;
}
.popup-content {
  margin: auto;
  background: #fff;
  width: auto;
  padding: 5px;
  border: 1px solid #d7d7d7;
}
`;
export default GlobalStyle;

export const PageHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 45px;
`;

export const DeviceNameLabel = styled(Label)`
  margin-bottom: 5px;
  font-size: 16px;
  overflow-wrap: break-word;
  max-width: 1000px;

  @media screen and (max-width:1500px) {
    max-width: 900px;
  }
  @media screen and (max-width:1400px) {
    max-width: 850px;
  }
  @media screen and (max-width:1366px) {
    max-width: 800px;
  }
`;

export const NoteLabel = styled(Label)`
  margin-bottom: 5px;
  max-width: 1000px;
  overflow-wrap: break-word;

  @media screen and (max-width:1500px) {
    max-width: 900px;
  }
  @media screen and (max-width:1400px) {
    max-width: 850px;
  }
  @media screen and (max-width:1366px) {
    max-width: 800px;
  }
`;

export const RightAlignedContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const CenterAlignedContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const Table = styled.table`
  width: 100%;
  border: 1px solid #d7d7d7;
  margin-top: 20px;
  margin-bottom: 30px;
  border-collapse: collapse;
  width: 100%;
  height: 50px;
  padding: 10px;
  font-family: Monorale;
`;

export const TR = styled.tr<{ bgColor?: string }>`
  border: 1px solid #d7d7d7;
  width: 100%;
  height: 50px;
  background: ${({ bgColor }) => bgColor ? bgColor : '#fff'};
`;

export const TD = styled.td<{ bgColor?: string, color?: string, fontWeight?: string, textAlign?: string }>`
  text-align: ${({ textAlign }) => textAlign ? textAlign : 'center'};;
  padding: 3px;
  border: 1px solid #d7d7d7;
  font-size: 14px;
  font-family: Lato;
  color: ${({ color }) => color ? color : '#788b91'};
  background: ${({ bgColor }) => bgColor ? bgColor : '#fff'};
  font-weight: ${({ fontWeight }) => fontWeight ? fontWeight : 'normal'};
`;

export const TH = styled.th<{ bgColor?: string }>`
  padding: 3px;
  border: 1px solid #d7d7d7;
  font-size: 14px;
  background: ${({ bgColor }) => bgColor ? bgColor : '#fff'};
`;

export const FieldSet = styled.fieldset`
  border-radius: 5px;
`;

export const LeftButton = styled(Button)`
  margin-right: 10px;
`;

export const FieldContainer = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const PopupTitle = styled.h1`
  font-family: Monorale;
  font-size: 26px;
  font-weight: 500;
  color: #5b636a;
  margin: 0 0 35px;
`;

export const SpinnerDesign = 'primary';

export const SelectField = styled.select`
  height: 40px;
  font-family: Lato;
  border: 1px solid rgb(217,218,217);
  box-sizing: border-box;
  padding-left: 10px;
  outline: none;
  color: #808080;
  font-size: 16px;
  background-color: #ffffff;
  margin-right: 40px;
  width: 100px;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  border-radius: 3px;
  background-color: #efefef;
`;

export const AlertContainer = styled.div`
  margin-top: 20px;
  margin-bottom: 10px;
`;

export const PopupContainer = styled.div`
  padding: 30px;
  width: 400px;
`;

export const overlayStyle = {
  background: 'rgba(0,0,0,0.5)'
};

export const FieldLabel = styled(Label)`
  white-space: nowrap;
`;

export const CloseIcon = styled.div`
  position: absolute;
  right: 13px;
  font-weight: bold;
  font-size: 1.8em;
  cursor: pointer;
  top: 0px;
  color: lightslategray;

  &:hover {
    color: #000;
  }
`;

export const InputField = styled.input`
    width: 100%;
    height: 40px;
    margin: 1px 0 2px;
    padding: 11px 15px 10px 15px;
    border-radius: 3px;
    border: solid 1px #d9dad9;
    background-color: #ffffff;
    font-family: Lato;
    color: gray;
    font-size: 16px;
    &:focus {
      outline: none;
      border-color: rgb(137, 188, 225);
  }
`;
